import { BlocOption } from '@amo/core/components/group-form';
import { useOnClickOutside } from '@amo/core/utils/hooks.js';
import _ from 'lodash';
import { useRef } from 'react';
import { getIconOptions, getTextOptions } from '../Options/getTextOptions';

const LastOptions = (props) => {
    const { data, changeValue, fractionnementChoisi, options, setShowLastOptions, postFill, typeSubscribe, codePromo } =
        props;
    const optionsChoisi = _.get(data, 'options');
    const ref = useRef();
    useOnClickOutside(ref, () => setShowLastOptions(false));

    return (
        <div style={{ background: 'rgba(0,0,0,.4)' }} className={'position-fixed bottom-0 top-0 start-0 end-0 p-4'}>
            <div
                className={'bg-white p-4 pb-2 overflow-scroll'}
                style={{
                    maxHeight: '90vh',
                    borderRadius: 20,
                    boxShadow: '0px 14px 50px rgb(0 0 0 / 15%)',
                    width: '90em',
                    maxWidth: '100%',
                    margin: '0 auto',
                }}
                ref={ref}
            >
                <h2 className={'text-dark f-24'} style={{ fontWeight: 600 }}>
                    Vous avez pensé à tout&nbsp;?
                </h2>
                <p className="f-14 text-secondary mb-4">Nos options & garanties complémentaires</p>
                <div className="row justify-content-center">
                    {!optionsChoisi?.PCC && _.find(options, ['idGroupe', 'PCC']) && (
                        <BlocOption
                            icon={getIconOptions('PCC')}
                            title={_.find(options, ['idGroupe', 'PCC']).labelGroupe}
                            fractionnement={fractionnementChoisi}
                            name={`options[PCC]`}
                            data={_.find(options, ['idGroupe', 'PCC']).data}
                            changeValue={changeValue}
                            selected={_.get(data, `options[PCC]`)}
                            text={getTextOptions('PCC')}
                            codePromo={codePromo}
                        />
                    )}

                    {!optionsChoisi?.ASS && _.find(options, ['idGroupe', 'ASS']) && (
                        <BlocOption
                            icon={getIconOptions('ASS')}
                            title={_.find(options, ['idGroupe', 'ASS']).labelGroupe}
                            fractionnement={fractionnementChoisi}
                            name={`options[ASS]`}
                            data={_.find(options, ['idGroupe', 'ASS']).data}
                            changeValue={changeValue}
                            selected={_.get(data, `options[ASS]`)}
                            text={getTextOptions('ASS')}
                            codePromo={codePromo}
                        />
                    )}
                </div>

                <button
                    className={`btn btn-primary btn-smaller btn-arrow mb-2`}
                    onClick={() => {
                        setShowLastOptions(false);
                        changeValue('typeDevis', typeSubscribe);
                        postFill({ getTarif: false });
                    }}
                >
                    C'est bon pour moi
                </button>
            </div>
        </div>
    );
};

export default LastOptions;
